// IslamicCalculatorList.js
import React from 'react';
import { islamicCalculators } from './ConstantsIslamicCalculator';
import SharedHelmet from '.././Helmet';
const TITLE = 'Kalkulator Zakat - Kalkulator Gratis untuk Zakat Harta dan Aset Syariah';
const DESCRIPTION = 'Jelajahi kumpulan kalkulator zakat gratis, termasuk kalkulator zakat harta, sedekah, dan aset syariah sesuai aturan Islam.';
const KEYWORDS = 'kalkulator zakat, kalkulator gratis, kalkulator zakat harta, kalkulator zakat emas, kalkulator zakat perak, kalkulator zakat buah-buahan, kalkulator zakat perdagangan, kalkulator zakat hewan, kalkulator konversi karat emas';
const OG_URL = 'https://do-calculate.com/id/zakat-calculators';
function CalculatorsList() {
    return (
        <div className="container ">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >Kalkulator</th>
                        <th >Deskripsi</th>
                    </tr>
                </thead>
                <tbody>
                    {islamicCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;